import { registerComponents } from "./loader";
import { Vue3Mq, MqResponsive } from "vue3-mq";
import "animate.css";
import VueAnimateOnScroll from "vue-animate-onscroll";
import VueNumber from "vue-number-animation";
import { createApp } from "vue";

const $els = document.querySelectorAll('[data-vue="app"]');

/*
new Vue({
  props:{
    nameComponent: {
      type: String,
      default: ''
      }
  },
  render: (h) =>h(Mycomp,
    {props:{componentName: $comp }}),
}).$mount($els)
*/

$els.forEach(($el) => {
  const app = createApp($el)
    .use(Vue3Mq, { preset: "tailwind" })
    .use(VueNumber)
    .use(VueAnimateOnScroll);

  registerComponents(app);
  app.mount($el);
});
